import { getDarkerColor, getLighterColor } from '@/utils/colorHelpers'

const GLOW_DARKEN_STOPS = [
    [0, 0],
    [0.12, 3],
    [0.25, 10],
    [0.4, 21],
    [0.56, 37],
    [0.73, 58],
    [0.9, 82],
    [1, 100],
]

export function getKillerPalette(color) {
    return {
        accent: color,
        light: getLighterColor(color, 45),
        soft: getLighterColor(color, 25),
        band: getDarkerColor(color, 30),
        shadow: getDarkerColor(color, 60),
        glow: GLOW_DARKEN_STOPS.map(([offset, darken]) => ({
            offset,
            color: getDarkerColor(color, darken),
        })),
    }
}
